import React from 'react';
import PropTypes from 'prop-types';

export default function Columns({ columns, minWidth }) {
  return (
    <div className="bipolar-horizontal-columns" style={{ minWidth }}>
      {columns.map((column, index) => (
        <div
          className="bipolar-horizontal-column"
          data-column-id={column}
          data-column-order={index}
        ></div>
      ))}
    </div>
  );
}
Columns.propTypes = {
  columns: PropTypes.array,
  minWidth: PropTypes.number,
};
